import React from "react";
import { getDinero } from "tsi-common-react/src/utils/money";
import { dynamicPlaceComponent } from "tsi-common-react/src/utils/react";
import { t } from "ttag";

// Render Financing Modal for Product Cards
dynamicPlaceComponent(
    '[data-place-react="card-financing-modal"]',
    async (elem) => {
        const { CardFinancingModal } = await import(
            "tsi-common-react/src/common/CardFinancingModal"
        );
        const productPrice = getDinero(elem.dataset.price);
        const productTitle = elem.dataset.title || "";
        return (
            <CardFinancingModal
                price={productPrice}
                title={productTitle}
                linkText={t`Financing available with qualifying order.`}
            />
        );
    },
).catch(console.error);
